
import Vue from "vue";
import vheader from "./header";
import vfooter from "./footer";


const publicComponents = {
  "v-header": vheader,
  "v-footer": vfooter,
 
};

Vue.use({
  install: (Vue) => {
    Object.keys(publicComponents).forEach((key) => {
      Vue.component(`${key}`, publicComponents[key]);
    });
  },
});



// WEBPACK FOOTER //
// ./src/components/index.js